import React, { useState,useRef,forwardRef } from "react";
import { TypeAnimation } from "react-type-animation";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import about from "../../images/about-image.png";
import TabButton from "./TabButton"; 
import heroImage from '../../images/homeImage.png';

const HeroSection = forwardRef((props, ref) => {
  const [activeTab, setActiveTab] = useState('skills');
  const aboutSectionRef = useRef(null); 
  const scrollToAbout = () => {
    if (aboutSectionRef.current) {
      aboutSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const openTab = (tabId) => {
    setActiveTab(tabId);
  };

  const TAB_CONTENT = {
    skills: <div className="px-6 flex"><div className="edu">
    <div className="about_cont">
      <ul >
        <li class="mb-2">
          <b>Programming Languages</b>
          <br /> C,  Javascript, Python, Solidity
        </li>
        <li class="mb-2">
          <b >Frontend  </b>
          <br /> HTML, CSS and React Js
        </li>
        <li class="mb-2">
          <b >Backend and Database</b>
          <br /> ExpressJs, Node Js and Mongo DB
          <br />
        </li>
        <li class="mb-2">
          <b >AI/ML</b>
          <br /> Numpy, Pandas, Seaborn, Matplotlib
        </li>
        <li class="mb-2">
          <b >Cybersecurity</b>
          <br /> Networking, Ethical Hacking
        </li>
      </ul>
    </div>
  </div>
</div>,
    education: <div className="px-6 "><div className="edu">
    <div className="about_cont">
     <p><b className="text-lg">B.Tech and M.Tech</b></p>
      
      
      <p className="text-lg">National Institute Of Technology Patna</p>
      
      <p className="text-lg">Branch: EE</p>      <span id="h">2023-2028</span>

    </div>
    <div className="about_cont">
      
      <p><b className="text-lg">Higher Secondary School</b></p>
     
      <p className="text-lg">Rosera Sr. Sec. School</p>
      
      <p className="text-lg">Grade: 83%</p>
      <span id="h">2021-2023</span>
    </div>
    <div className="about_cont">
     
      <p><b className="text-lg">Matriculation</b></p>
     
      <p className="text-lg">Girls' High School</p>
    
      <p className="text-lg">Grade: 95%</p>      <span id="h">2020-2021</span>

    </div>
  </div> 
  
</div>,
   };

   return (
    <>
      <section className="lg:py-10">
        <div className="grid grid-cols-1 sm:grid-cols-12">
          <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="col-span-8 place-self-center lg:ml-10   px-5 sm:px-5 sm:text-left justify-self-start"
          >
            <h1 className="text-white lg:m-5 m-2 mt-10 text-4xl sm:text-6xl flex flex-col lg:text-8xl lg:leading-normal font-extrabold">
              <span className="text-transparent font-bold bg-clip-text mt-4 sm:mt-4 lg:mt-5 bg-gradient-to-r from-primary-400 to-secondary-600">
                Hello, I&apos;m{" "}
              </span>
              <span className="text-white text-4xl lg:mt-4 font-bold sm:text-7xl lg:text-7xl mb-3 mt-1">
                Seema Kumari
              </span>
              <TypeAnimation
                sequence={[
                  "MERN Developer",
                  1000,
                  "Web Developer",
                  1000,
                  "App Developer",
                  1000,
                  "UI/UX Designer",
                  1000,
                  "Blockchain Developer",
                  1000,
                  "Coder",
                  1000,
                  "Electrical Engineer",
                  1000,
                ]}
                wrapper="span"
                speed={50}
                repeat={Infinity}
                className="text-transparent bg-clip-text lg:my-5 text-white my-1 bg-gradient-to-r text-4xl sm:text-5xl lg:text-6xl mb-5 "
              />
            </h1>
            <p className="text-[#ADB7BE] text-base lg:mt-3 lg:m-5 m-2 sm:text-lg mb-6 lg:text-xl ">
              Gen AI intern at Prodigy Info. & Ex-SDE intern at Astomverse 
            </p>
            <div className="px-6 lg:mb-0 mb-10">
              <a
                href="mailto:seemakumari8122005@gmail.com"
                className="px-6 inline-block py-3 w-full lg:mr-4 text-center sm:w-fit rounded-full  bg-gradient-to-br from-primary-500 to-secondary-500 hover:bg-slate-200 text-white "
              >
                Get in touch
              </a>
              <Link
                to="https://drive.google.com/file/d/108vi9YTXXvBYC__y_eIsga1oek_Az6Vy/view?usp=sharing"
                target="_blank"
                className="px-1 inline-block py-1 w-full text-center sm:w-fit rounded-full bg-gradient-to-br from-primary-500 to-secondary-500 hover:bg-slate-800 text-white mt-3"
              >
                <span className="block bg-[#121212] hover:bg-slate-800 rounded-full px-5 py-2 ">
                  Download CV
                </span>
              </Link>
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="col-span-4 place-self-center mt-4  hidden lg:block"
          >
            <div className="rounded-full bg-[#181818] w-[300px] mr-30 h-[250px] lg:w-[430px] lg:h-[400px] relative ">
              <img
                src={heroImage}
                alt="hero image"
                className="absolute -translate-x-1  transform -translate-y-1/2 top-1/2"
                width={300}
                height={300}
              />
            </div>
          </motion.div>
        </div>
      </section>
      <section className="text-white" id="about" ref={ref}>
        <div className="md:grid md:grid-cols-2 items-start  px-4 xl:gap-16 sm:py-16 sm:px-16 xl:px-16">
          <img
            src={about}
            alt="About Me"
            className="px-5 w-3/4 md:w-1/2 lg:w-[700px] lg:mx-auto lg:mt-40"
          />
          <div className="mt-4 md:mt-0 text-left flex flex-col h-full lg:m-20">
            <h2 className="text-4xl font-bold text-white mb-4 px-5">About Me</h2>
            <p className="text-base lg:text-lg px-5">
              Hello, I'm Seema Kumari, pursuing a BTech+MTech (Dual Degree) in
              Electrical Engineering from the National Institute of Technology,
              Patna.
              Currently, I'm immersed in learning Generative Artificial
              Intelligence, alongside exploring diverse aspects of Innovations.
             <br />
              <br />  My
              technical skills span multiple programming languages including
              Java, C, and JavaScript, with proficiency in frameworks like
              React.js. My expertise extends into the realm of ethical hacking, with
              knowledge of tools like Burp Suite, Wireshark, and Metasploit
              Framework.
            </p>
            <p className="px-5">
              <span className="flex flex-row gap-2 my-3 font-bold text-2xl ">
               
                NIT Patna Student Clubs:
              </span>
              <ul class="list-disc list-inside text-white">
                <li class="mb-2">
                  Web  member in Tesla Club.
                </li>
                <li class="mb-2">
                  Technical  member in Robotics Club.
                </li>
                <li class="mb-2">
                  Blockchain  member in Hackslash.
                </li>
              </ul>
            </p>
            <div className="flex flex-row justify-start mt-8 px-5">
              <TabButton
                selectTab={() => openTab('skills')}
                active={activeTab === 'skills'}
              >
                Skills
              </TabButton>
              <TabButton
                selectTab={() => openTab('education')}
                active={activeTab === 'education'}
              >
                Education
              </TabButton>
             
            </div>
            <div className="mt-8">
              {TAB_CONTENT[activeTab]}
            </div>
          </div>
        </div>
      </section><h1 className="text-4xl sm-text-md ml-10 font-bold mx-5 mb-3">My Interests</h1>
          <div className="flex m-5 gap-2 lg:gap-10 lg:flex-nowrap  flex-wrap">
          <div className="  px-6 rounded-lg shadow-lg border-primary-800  border">
              <br/>

                  <span className="font-bold text-2xl ">Cybersecurity</span>
                
<br/>
<br/>
                <p>
                  My journey into Cybersecurity is all about understanding how
                  to protect systems and data from threats. I'm learning about
                  various types of cyber attacks, ethical hacking techniques,
                  and security tools like Burp Suite, Wireshark, and Metasploit.
                </p>                  <br/>

              </div>          <div className="  px-6 rounded-lg shadow-lg border-primary-800 border">

              <br/>

                  <span className="font-bold text-2xl ">Artificial Intelligence</span>
                  <br/>
                  <br/>


                <p>
                  In my exploration of AI/ML, I'm studying key topics like supervised and
                  unsupervised learning, neural networks, natural language
                  processing, and computer vision. By working with libraries and
                  frameworks such as TensorFlow, Keras, and scikit-learn.<br/>
                </p><br/>
              </div>          <div className="  px-6 rounded-lg shadow-lg border-primary-800 border">

                <br/>
                  <span className="font-bold text-2xl ">Web Development</span>
                  <br/>
                  <br/>

                <p>
                  I'm also advancing my skills in Web Development. I'm working with
                  technologies like HTML, CSS, JS, and React.js.
                  Additionally, I'm learning about backend development,
                  databases, and deployment strategies.
                </p><br/>
              </div>
              <div className=" px-6 rounded-lg shadow-lg border-primary-800 border">
                <br/>
                  <b className="font-bold text-2xl  py-20 ">Data Structures & Algorithms</b>

                  <br/>
                <p>
                  I'm currently diving into DSA to
                  build a solid foundation in problem-solving and coding
                  efficiency. I'm focusing on understanding fundamental concepts
                  like arrays, linked lists, stacks, queues, trees, and graphs.
               
                </p><br/>
              </div></div>
    </>
  );
});

export default HeroSection;
